import types from '../mutation-types';
import GuestJourneyAPI from '../../api/guestJourney';

export const state = {
  hasPMSConnection: false,
  uiFlags: {
    isFetching: false,
    hasFetched: false,
  },
  reservations: [],
  isFetchingReservations: false,
  fetchReservationsError: null,
  fetchStatusError: null,
};

export const getters = {
  hasPMSConnection(_state) {
    return _state.hasPMSConnection;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  reservations(_state) {
    return _state.reservations;
  },
  isFetchingReservations(_state) {
    return _state.isFetchingReservations;
  },
  fetchReservationsError(_state) {
    return _state.fetchReservationsError;
  },
  fetchStatusError(_state) {
    return _state.fetchStatusError;
  },
};

export const actions = {
  fetchStatus: async ({ commit }, accountId) => {
    commit(types.SET_GUEST_JOURNEY_UI_FLAG, { isFetching: true });
    commit(types.SET_GUEST_JOURNEY_FETCH_STATUS_ERROR, null);
    try {
      const response = await GuestJourneyAPI.getIntegrationsStatus(accountId);
      const hasPMSConnection = response?.data?.integrations?.length > 0;
      commit(types.SET_PMS_CONNECTION_STATUS, hasPMSConnection);
    } catch (error) {
      commit(types.SET_PMS_CONNECTION_STATUS, false);
      commit(
        types.SET_GUEST_JOURNEY_FETCH_STATUS_ERROR,
        error?.message || 'fetch_status_failed'
      );
    } finally {
      commit(types.SET_GUEST_JOURNEY_UI_FLAG, {
        isFetching: false,
        hasFetched: true,
      });
    }
  },
  fetchReservations: async (
    { commit },
    { accountId, status = 'CHECKED_IN' } = {}
  ) => {
    commit(types.SET_FETCHING_RESERVATIONS, true);
    commit(types.SET_FETCH_RESERVATIONS_ERROR, null);
    try {
      const response = await GuestJourneyAPI.getReservations(accountId, status);
      commit(types.SET_RESERVATIONS, response?.data?.reservations || []);
    } catch (error) {
      commit(types.SET_FETCH_RESERVATIONS_ERROR, error?.message || 'error');
    } finally {
      commit(types.SET_FETCHING_RESERVATIONS, false);
    }
  },
  clearStatus: ({ commit }) => {
    commit(types.SET_PMS_CONNECTION_STATUS, false);
    commit(types.SET_GUEST_JOURNEY_UI_FLAG, {
      isFetching: false,
      hasFetched: false,
    });
    commit(types.SET_RESERVATIONS, []);
    commit(types.SET_FETCHING_RESERVATIONS, false);
    commit(types.SET_FETCH_RESERVATIONS_ERROR, null);
    commit(types.SET_GUEST_JOURNEY_FETCH_STATUS_ERROR, null);
  },
};

export const mutations = {
  [types.SET_GUEST_JOURNEY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_PMS_CONNECTION_STATUS](_state, hasPMSConnection) {
    _state.hasPMSConnection = hasPMSConnection;
  },
  [types.SET_RESERVATIONS](_state, reservations) {
    _state.reservations = reservations;
  },
  [types.SET_FETCHING_RESERVATIONS](_state, isFetching) {
    _state.isFetchingReservations = isFetching;
  },
  [types.SET_FETCH_RESERVATIONS_ERROR](_state, error) {
    _state.fetchReservationsError = error;
  },
  [types.SET_GUEST_JOURNEY_FETCH_STATUS_ERROR](_state, error) {
    _state.fetchStatusError = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
